import { NavigationMenuRoutes } from "@ubisolutions/core";

export const APP_NAVIGATION: NavigationMenuRoutes[] = [
    {
        key: "routing.workspace._title",
        route: "/workspace",
        icon: "work",
    },
    {
        key: "routing.administration._title",
        route: "/administration",
        icon: "settings",
        anyReadPermission: [
            "Site",
            "Manager",
            "Station",
            "Tag",
            "ClientAlert",
            "Client",
            "Group",
            "User",
            "Role",
            "Organization",
        ],
    },
    {
        key: "routing.administration-ubi._title",
        route: "/administration-ubi",
        icon: "business",
        SuperAdminOnly: true,
    },
];
